var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.52 491.52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.916 42.316H80.604c-10.869 0-19.681 8.811-19.681 19.681v409.842c0 10.869 8.812 19.681 19.681 19.681h330.312c10.869 0 19.681-8.811 19.681-19.681V61.997c0-10.869-8.812-19.681-19.681-19.681z",
    fill: "#64798a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebf0f3",
    d: "M82.586 68.178H408.95v402.586H82.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.586 58.307H408.95v402.586H82.586z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a556a",
    d: "M143.821 42.317h203.904v15.99H143.821z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e6e9",
    d: "M143.821 58.307h203.904v35.144H143.821z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M325.086 29.252h-49.278C275.328 13.026 262.1 0 245.761 0c-16.344 0-29.569 13.026-30.049 29.252h-49.278a8.167 8.167 0 00-8.169 8.168v41.57h174.991V37.42a8.169 8.169 0 00-8.17-8.168z",
    fill: "#dc8744"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e56353",
    d: "M104.038 213.914h31.181v43.039h-31.181z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#27a2db",
    d: "M146.048 165.325h31.181v91.633h-31.181z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#44c4a1",
    d: "M188.063 116.198h31.181v140.754h-31.181z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd462",
    d: "M230.072 182.098h31.181v74.854h-31.181z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d15241",
    d: "M104.038 243.446h31.181v13.512h-31.181z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d93ba",
    d: "M146.048 243.446h31.181v13.512h-31.181z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ea69b",
    d: "M188.063 243.446h31.181v13.512h-31.181z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6c358",
    d: "M230.072 243.446h31.181v13.512h-31.181z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d5d6db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.038 278.989h283.443v9.636H104.038zM291.425 126.828h96.046v9.636h-96.046zM291.425 164.864h96.046v9.636h-96.046zM291.425 202.921h96.046v9.636h-96.046zM291.425 240.947h96.046v9.636h-96.046zM104.038 317.056h283.443v9.636H104.038zM104.038 354.099h283.443v95.365H104.038z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebf0f3",
    d: "M104.038 350.208h283.443v95.365H104.038z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.251 442.96a2.682 2.682 0 01-1.752-.65 2.688 2.688 0 01-.283-3.786l36.091-41.933a2.68 2.68 0 013.356-.587l39.982 22.519 35.357-36.6a2.687 2.687 0 013.293-.451l42.625 25.005 33.039-36.474a2.67 2.67 0 013.22-.582l38.346 19.713 33.06-28.392c1.143-.96 2.832-.839 3.786.283a2.688 2.688 0 01-.283 3.786l-34.434 29.572a2.699 2.699 0 01-2.979.351l-38.115-19.598-33.123 36.563c-.85.944-2.245 1.148-3.356.514l-42.688-25.041-35.325 36.573a2.696 2.696 0 01-3.251.472l-39.877-22.456-34.654 40.265a2.676 2.676 0 01-2.035.934z",
    fill: "#44c4a1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.251 442.96a2.684 2.684 0 01-2.444-1.573 2.677 2.677 0 011.332-3.556l44.272-20.112a2.624 2.624 0 012.15-.031l31.581 13.2 31.833-16.944a2.68 2.68 0 011.972-.22l42.531 11.674 39.101-23.389a2.724 2.724 0 011.993-.309l47.355 11.296 13.299-9.167c1.217-.829 2.895-.53 3.734.687a2.689 2.689 0 01-.692 3.739l-14.285 9.843a2.735 2.735 0 01-2.14.399l-47.45-11.322-39.143 23.421a2.715 2.715 0 01-2.087.288l-42.615-11.695-32.011 17.039c-.703.388-1.552.414-2.297.105l-31.675-13.242-43.202 19.629a2.7 2.7 0 01-1.112.24z",
    fill: "#e56353"
  })));
}

export default __webpack_public_path__ + "1fb0efa8a4f11b476076b9433c1267c9.svg";
export { SvgReport as ReactComponent };